var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopFiveCategory({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "235px",
    height: "125px",
    viewBox: "0 0 235 125",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ED8D66A0-7E9E-47AC-AAF1-04589AC9BEF5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 235,
    height: 125,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Chat-Simplified-Widget---Style-Guide",
    transform: "translate(-729.000000, -1875.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#EEEEEE",
    x: 0,
    y: 0,
    width: 1463,
    height: 2535
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(729.000000, 1875.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Background",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 235,
    height: 125
  }), /*#__PURE__*/React.createElement("g", {
    id: "Chart",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-9.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gold"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26,27 C26,29.2106667 24.2106667,31 22,31 C19.792,31 18,29.2106667 18,27 C18,24.792 19.792,23 22,23 C24.2106667,23 26,24.792 26,27",
    id: "Fill-4",
    fill: "#FFC000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,37 C44,39.2106667 42.2106667,41 40,41 C37.7893333,41 36,39.2106667 36,37 C36,34.792 37.7893333,33 40,33 C42.2106667,33 44,34.792 44,37",
    id: "Fill-7",
    fill: "#FFC000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62,77 C62,79.2106667 60.2106667,81 58,81 C55.7893333,81 54,79.2106667 54,77 C54,74.792 55.7893333,73 58,73 C60.2106667,73 62,74.792 62,77",
    id: "Fill-10",
    fill: "#FFC000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79,98 C79,100.210667 77.208,102 75,102 C72.7893333,102 71,100.210667 71,98 C71,95.792 72.7893333,94 75,94 C77.208,94 79,95.792 79,98",
    id: "Fill-13",
    fill: "#FFC000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97,102 C97,104.210667 95.208,106 93,106 C90.7893333,106 89,104.210667 89,102 C89,99.792 90.7893333,98 93,98 C95.208,98 97,99.792 97,102",
    id: "Fill-16",
    fill: "#FFC000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,102 C115,104.210667 113.208,106 111,106 C108.789333,106 107,104.210667 107,102 C107,99.792 108.789333,98 111,98 C113.208,98 115,99.792 115,102",
    id: "Fill-19",
    fill: "#FFC000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,111 C132,113.210667 130.210667,115 128,115 C125.792,115 124,113.210667 124,111 C124,108.792 125.792,107 128,107 C130.210667,107 132,108.792 132,111",
    id: "Fill-22",
    fill: "#FFC000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150,102 C150,104.210667 148.210667,106 146,106 C143.792,106 142,104.210667 142,102 C142,99.792 143.792,98 146,98 C148.210667,98 150,99.792 150,102",
    id: "Fill-25",
    fill: "#FFC000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168,98 C168,100.210667 166.210667,102 164,102 C161.792,102 160,100.210667 160,98 C160,95.792 161.792,94 164,94 C166.210667,94 168,95.792 168,98",
    id: "Fill-28",
    fill: "#FFC000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186,94 C186,96.2106667 184.210667,98 182,98 C179.789333,98 178,96.2106667 178,94 C178,91.792 179.789333,90 182,90 C184.210667,90 186,91.792 186,94",
    id: "Fill-31",
    fill: "#FFC000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204,48 C204,50.2106667 202.210667,52 200,52 C197.789333,52 196,50.2106667 196,48 C196,45.792 197.789333,44 200,44 C202.210667,44 204,45.792 204,48",
    id: "Fill-34",
    fill: "#FFC000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221,12 C221,14.2106667 219.208,16 217,16 C214.789333,16 213,14.2106667 213,12 C213,9.792 214.789333,8 217,8 C219.208,8 221,9.792 221,12",
    id: "Fill-37",
    fill: "#FFC000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239,4 C239,6.21066667 237.208,8 235,8 C232.789333,8 231,6.21066667 231,4 C231,1.792 232.789333,0 235,0 C237.208,0 239,1.792 239,4",
    id: "Fill-40",
    fill: "#FFC000"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    stroke: "#FFC000",
    strokeWidth: 2,
    fillRule: "nonzero",
    points: "4 8.0194321 21.6352442 26.591752 39.6857707 34.9020282 58.0365625 76.5902646 75.8601087 98.3186788 92.9426612 102.851748 111.02983 102.851748 128.059455 112 146.448925 102.851748 164.609379 98.3186788 182.173374 92.935001 199.664083 47.3916554 218.109535 11.2723778 235.065874 3 253.206989 26.591752 271 34.9020282"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26,69 C26,71.2106667 24.2106667,73 22,73 C19.7893333,73 18,71.2106667 18,69 C18,66.792 19.7893333,65 22,65 C24.2106667,65 26,66.792 26,69",
    id: "Fill-52",
    fill: "#2E5799"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43,39 C43,41.2106667 41.2106667,43 39,43 C36.7893333,43 35,41.2106667 35,39 C35,36.792 36.7893333,35 39,35 C41.2106667,35 43,36.792 43,39",
    id: "Fill-55",
    fill: "#2E5799"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61,44 C61,46.2106667 59.208,48 57,48 C54.7893333,48 53,46.2106667 53,44 C53,41.792 54.7893333,40 57,40 C59.208,40 61,41.792 61,44",
    id: "Fill-58",
    fill: "#2E5799"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78,39 C78,41.2106667 76.208,43 74,43 C71.7893333,43 70,41.2106667 70,39 C70,36.792 71.7893333,35 74,35 C76.208,35 78,36.792 78,39",
    id: "Fill-61",
    fill: "#2E5799"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,44 C96,46.2106667 94.208,48 92,48 C89.7893333,48 88,46.2106667 88,44 C88,41.792 89.7893333,40 92,40 C94.208,40 96,41.792 96,44",
    id: "Fill-64",
    fill: "#2E5799"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,35 C115,37.2106667 113.210667,39 111,39 C108.792,39 107,37.2106667 107,35 C107,32.792 108.792,31 111,31 C113.210667,31 115,32.792 115,35",
    id: "Fill-67",
    fill: "#2E5799"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,29 C132,31.2106667 130.210667,33 128,33 C125.792,33 124,31.2106667 124,29 C124,26.792 125.792,25 128,25 C130.210667,25 132,26.792 132,29",
    id: "Fill-70",
    fill: "#2E5799"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150,35 C150,37.2106667 148.210667,39 146,39 C143.792,39 142,37.2106667 142,35 C142,32.792 143.792,31 146,31 C148.210667,31 150,32.792 150,35",
    id: "Fill-73",
    fill: "#2E5799"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167,24 C167,26.2106667 165.210667,28 163,28 C160.789333,28 159,26.2106667 159,24 C159,21.792 160.789333,20 163,20 C165.210667,20 167,21.792 167,24",
    id: "Fill-76",
    fill: "#2E5799"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,9 C185,11.2106667 183.210667,13 181,13 C178.789333,13 177,11.2106667 177,9 C177,6.792 178.789333,5 181,5 C183.210667,5 185,6.792 185,9",
    id: "Fill-79",
    fill: "#2E5799"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202,4 C202,6.21066667 200.208,8 198,8 C195.789333,8 194,6.21066667 194,4 C194,1.792 195.789333,0 198,0 C200.208,0 202,1.792 202,4",
    id: "Fill-82",
    fill: "#2E5799"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220,9 C220,11.2106667 218.208,13 216,13 C213.789333,13 212,11.2106667 212,9 C212,6.792 213.789333,5 216,5 C218.208,5 220,6.792 220,9",
    id: "Fill-85",
    fill: "#2E5799"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239,24 C239,26.2106667 237.208,28 235,28 C232.789333,28 231,26.2106667 231,24 C231,21.792 232.789333,20 235,20 C237.208,20 239,21.792 239,24",
    id: "Fill-88",
    fill: "#2E5799"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#2E5799",
    strokeWidth: 2,
    fillRule: "nonzero",
    points: "4 88 21.4195814 69.7291039 39.450644 38.700848 56.6606329 44.2751782 74.3976554 38.700848 92.4287179 44.2751782 110.545245 33.9355438 128.675 30.0096628 145.927721 33.9355438 163.969975 24.678508 181.46383 9.73958363 199.0228 5 216.966363 9.73958363 235.38914 24.678508 253 33.9355438"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy",
    transform: "translate(128.000000, 68.000000) scale(1, -1) translate(-128.000000, -68.000000) translate(0.000000, 45.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26,34 C26,36.2106667 24.2106667,38 22,38 C19.7893333,38 18,36.2106667 18,34 C18,31.792 19.7893333,30 22,30 C24.2106667,30 26,31.792 26,34",
    id: "Fill-52",
    fill: "#72992E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43,19 C43,21.2106667 41.2106667,23 39,23 C36.7893333,23 35,21.2106667 35,19 C35,16.792 36.7893333,15 39,15 C41.2106667,15 43,16.792 43,19",
    id: "Fill-55",
    fill: "#72992E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61,21 C61,23.2106667 59.208,25 57,25 C54.7893333,25 53,23.2106667 53,21 C53,18.792 54.7893333,17 57,17 C59.208,17 61,18.792 61,21",
    id: "Fill-58",
    fill: "#72992E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78,19 C78,21.2106667 76.208,23 74,23 C71.7893333,23 70,21.2106667 70,19 C70,16.792 71.7893333,15 74,15 C76.208,15 78,16.792 78,19",
    id: "Fill-61",
    fill: "#72992E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,21 C96,23.2106667 94.208,25 92,25 C89.7893333,25 88,23.2106667 88,21 C88,18.792 89.7893333,17 92,17 C94.208,17 96,18.792 96,21",
    id: "Fill-64",
    fill: "#72992E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,17 C115,19.2106667 113.210667,21 111,21 C108.792,21 107,19.2106667 107,17 C107,14.792 108.792,13 111,13 C113.210667,13 115,14.792 115,17",
    id: "Fill-67",
    fill: "#72992E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,15 C132,17.2106667 130.210667,19 128,19 C125.792,19 124,17.2106667 124,15 C124,12.792 125.792,11 128,11 C130.210667,11 132,12.792 132,15",
    id: "Fill-70",
    fill: "#72992E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150,17 C150,19.2106667 148.210667,21 146,21 C143.792,21 142,19.2106667 142,17 C142,14.792 143.792,13 146,13 C148.210667,13 150,14.792 150,17",
    id: "Fill-73",
    fill: "#72992E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167,13 C167,15.2106667 165.210667,17 163,17 C160.789333,17 159,15.2106667 159,13 C159,10.792 160.789333,9 163,9 C165.210667,9 167,10.792 167,13",
    id: "Fill-76",
    fill: "#72992E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,6 C185,8.21066667 183.210667,10 181,10 C178.789333,10 177,8.21066667 177,6 C177,3.792 178.789333,2 181,2 C183.210667,2 185,3.792 185,6",
    id: "Fill-79",
    fill: "#72992E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202,4 C202,6.21066667 200.208,8 198,8 C195.789333,8 194,6.21066667 194,4 C194,1.792 195.789333,0 198,0 C200.208,0 202,1.792 202,4",
    id: "Fill-82",
    fill: "#72992E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220,6 C220,8.21066667 218.208,10 216,10 C213.789333,10 212,8.21066667 212,6 C212,3.792 213.789333,2 216,2 C218.208,2 220,3.792 220,6",
    id: "Fill-85",
    fill: "#72992E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239,13 C239,15.2106667 237.208,17 235,17 C232.789333,17 231,15.2106667 231,13 C231,10.792 232.789333,9 235,9 C237.208,9 239,10.792 239,13",
    id: "Fill-88",
    fill: "#72992E"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#72992E",
    strokeWidth: 2,
    fillRule: "nonzero",
    points: "4 43 21.4195814 34.4148801 39.450644 19.8353382 56.6606329 22.4546018 74.3976554 19.8353382 92.4287179 22.4546018 110.545245 17.5962194 128.675 15.7515283 145.927721 17.5962194 163.969975 13.2465279 181.46383 6.22703327 199.0228 4 216.966363 6.22703327 235.38914 13.2465279 253 17.5962194"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CCCCCC",
    mask: "url(#mask-2)",
    x: 0,
    y: 123,
    width: 235,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CCCCCC",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 2,
    height: 125
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopFiveCategory);
export default __webpack_public_path__ + "static/media/top-five-category.77e47abb17a5c7bca3e8fd224a017a42.svg";
export { ForwardRef as ReactComponent };